import { prefersReducedMotion } from '@theme/utilities';

const TARGETS = [
  '#shopify-section-hero_jVaWmY .hero__media',
  '#shopify-section-hero_jVaWmY .hero__content-wrapper > *',
  '.media-with-content .media-block',
  '.media-with-content .media-with-content__content',
  '#shopify-section-product_buy .product-information__media',
  '#shopify-section-product_buy .product-details',
  '#shopify-section-faq .text-block',
  '#shopify-section-faq .accordion > accordion-custom',
].join(', ');

const VISIBLE_CLASS = 'is-visible';

/** @type {IntersectionObserver | null} */
let observer = null;

/**
 * Reveal any not-yet-seen target currently in the DOM. Safe to call
 * repeatedly (e.g. after the theme editor re-renders a section) since
 * already-revealed elements are excluded by the selector itself.
 */
function scan() {
  const elements = document.querySelectorAll(`${TARGETS}`);

  if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
    elements.forEach((el) => el.classList.add(VISIBLE_CLASS));
    return;
  }

  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add(VISIBLE_CLASS);
          observer?.unobserve(entry.target);
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );
  }

  elements.forEach((el) => {
    if (!el.classList.contains(VISIBLE_CLASS)) observer?.observe(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scan, { once: true });
} else {
  scan();
}

// Theme editor: re-scan when a section is added/re-rendered.
document.addEventListener('shopify:section:load', scan);
